// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"279":"8de90bb4","694":"00158762"}[chunkId] + ".chunk.css");